/**
 * Generated by orval v7.11.2 🍺
 * Do not edit manually.
 * ScaleFi Nub APIs
 * Scale Fi Apis
 * OpenAPI spec version: v0.0.1
 */

export type NotificationPlatforms = typeof NotificationPlatforms[keyof typeof NotificationPlatforms];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const NotificationPlatforms = {
  WHATS_APP: 'WHATS_APP',
  SMS: 'SMS',
  EMAIL: 'EMAIL',
  IN_APP: 'IN_APP',
} as const;
